var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.53,9h-.6A7,7,0,0,0,9.07,9h-.6A5.48,5.48,0,0,0,3,14.47v1.06A5.48,5.48,0,0,0,8.47,21a1,1,0,0,0,0-2A3.48,3.48,0,0,1,5,15.53V14.47A3.48,3.48,0,0,1,8.47,11H10a1,1,0,0,0,1-1,5,5,0,0,1,10,0,1,1,0,0,0,1,1h1.53A3.48,3.48,0,0,1,27,14.47v1.06A3.48,3.48,0,0,1,23.53,19a1,1,0,0,0,0,2A5.48,5.48,0,0,0,29,15.53V14.47A5.48,5.48,0,0,0,23.53,9Z",
    fill: "#000000",
    className: "color000 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.71,13.29a1,1,0,0,0-.33-.21,1,1,0,0,0-.76,0,1,1,0,0,0-.33.21l-4,4a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L15,16.41V28a1,1,0,0,0,2,0V16.41l2.29,2.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z",
    fill: "#000000",
    className: "color000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadicon);
export default __webpack_public_path__ + "static/media/uploadicon.01b74b48a7c75d99a8f7c06ef8236042.svg";
export { ForwardRef as ReactComponent };